import { render, staticRenderFns } from "./KeepWindowOpenedButton.vue?vue&type=template&id=0f46d79a"
import script from "./KeepWindowOpenedButton.vue?vue&type=script&lang=js"
export * from "./KeepWindowOpenedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports